import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { UrlBuilderService } from "@shared/services/url-builder.service";
import { FeatureManagementService } from '@shared/services/feature-management/feature-management.service';
import { IFeature } from '../interfaces/feature.interface';

const ConfigurableFeatures = [
  'max_aerobic',
  'max_power',
];

@Component({
  selector: 'app-metric-settings',
  templateUrl: './metric-settings.component.html',
  styleUrls: ['./metric-settings.component.scss'],
})
export class MetricSettingsComponent implements OnInit {
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private destroyRef: DestroyRef = inject(DestroyRef);
  private urlBuilder: UrlBuilderService = inject(UrlBuilderService);
  private featureManagementService: FeatureManagementService = inject(FeatureManagementService);

  private featureList: IFeature[] | null = [];
  private configurableFeatures: string[] = [];

  public tabIndexToReturn: number = 0;
  public customUrl: string | undefined;

  ngOnInit(): void {
    this.featureList = this.activatedRoute.snapshot?.data?.data;
    this.setConfigurableFeatures();

    // this.loadInitialData();

    this.activatedRoute.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params: Params): void => {
        this.setTabIndexToReturn(params.tab_index_to_return);
        this.customUrl = this.urlBuilder.getCreatedCustomUrl('/home/my-inscyd', 'tab_index_to_return', this.tabIndexToReturn);
      });
  }

  public metricEnabled(slug: string): boolean {
    return this.configurableFeatures.includes(slug);
  }

  public getIdForFeature(slug: string): number {
    const featureData = this.featureList?.find(v => v.slug === slug);
    if (!featureData) {
      return -1;
    }
    return featureData.id;
  }

  /**
   * Based on the user's enabled features we show/hide the settings dropdowns.
   * Only features that are currently enabled for the user should be visible
   */
  private setConfigurableFeatures(): void {
    const enabledFeatures = this.featureManagementService.getEnabledFeatures();
    this.configurableFeatures = ConfigurableFeatures.filter(slug => enabledFeatures.includes(slug));
  }

  public setTabIndexToReturn(returnIndex: number): void {
    this.tabIndexToReturn = returnIndex;
  }
}
